import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import { agentBillingRouter } from "@v2/trpc/routes/agentBilling";

import { SubscriptionDraft } from "../models/SubscriptionDraft";
import {
  MOCK_CUSTOM_PRICING_SUBSCRIPTION,
  useMockCustomPricingEnabled,
} from "./mockCustomPricing";

export function useAgentBillingSubscription({
  hasOwnErrorState = false,
}: {
  /** Skip the global error modal when the caller renders its own error state. */
  hasOwnErrorState?: boolean;
} = {}) {
  const workspaceId = useCurrentWorkspaceId();
  const [isMockCustomPricingEnabled] = useMockCustomPricingEnabled();

  const query = agentBillingRouter.subscription.find.useQuery(
    workspaceId ? { workspaceId } : skipToken,
    { meta: { reploIgnoreDefaultErrorHandling: hasOwnErrorState } },
  );

  const data = isMockCustomPricingEnabled
    ? MOCK_CUSTOM_PRICING_SUBSCRIPTION
    : query.data;

  return {
    ...query,
    data,
    currentDraft: data ? new SubscriptionDraft(data) : null,
  };
}
